import { ChangeDetectorRef, EventEmitter, Input, Output } from "@angular/core";
import { Component, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { DevicePilomat } from "src/app/model/devicePilomat";
import { DeviceService } from "src/app/service/device.service";
import { Subscription, interval } from 'rxjs';
import { Log } from "src/app/util/log";
import { startWith, switchMap } from 'rxjs/operators';
import { Overlay } from "@angular/cdk/overlay";
import { MatDialog } from "@angular/material/dialog";
import { SerialsList } from "src/app/model/serialsList";
import { DeviceState } from "src/app/model/deviceState";

@Component({
  selector: 'app-add-group-devices-map',
  templateUrl: './add-group-devices-map.component.html',
  styleUrls: ['./add-group-devices-map.component.css']
})
export class AddGroupDevicesMapComponent implements OnInit {



  @ViewChild("devicesmaploader", { static: true }) loader;

  @Input() deviceList;
  @Input() usergroup: boolean;
  @Input() canUserEdit;


  @Output() onDeviceSelected = new EventEmitter<DevicePilomat>();
  @Output() onDeviceDeselected = new EventEmitter<DevicePilomat>();
  @Output() selectedDeviceEmitter = new EventEmitter<DevicePilomat>();

  map: google.maps.Map;
  latitude: number;
  longitude: number;
  mapZoom: number;
  subscription: Subscription;

  timeInterval: Subscription;

  constructor(
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private overlay: Overlay,
    private deviceService: DeviceService
  ) { }

  ngOnInit(): void {
  }



  ngOnDestroy(): void {

    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }
  }

  ngAfterViewInit() {

    this.loader.hideLoading();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }
    this.startUpdatingDevicesStates();
  }

  onMarkerClicked(device) {

    Log.debug("onMarkerClicked: " + JSON.stringify(device));
  }

  startUpdatingDevicesStates() {

    Log.debug("startUpdatingDevicesStates");

    let serials: SerialsList = new SerialsList();

    for (let i = 0; i < this.deviceList.length; i++) {
      serials.devices.push(this.deviceList[i].serial);
    }

    Log.debug("serials: " + JSON.stringify(serials));

    this.timeInterval = interval(15000).pipe(
      startWith(0),
      switchMap(() => this.deviceService.getDevicesState(serials))
    ).subscribe(res => this.updateDeviceIcons(res), err => Log.debug('err: ' + JSON.stringify(err)));
  }

  addSelectedDevice(device) {

    if (device.selected) {

      device.selected = false;
      device.shortPermissions = " - ";

      this.onDeviceDeselected.emit(device);

    } else {
      this.modifyPermissions(device);
      device.selected = true;
      this.onDeviceSelected.emit(device);
    }

    device.updateIcon();
  }

  updateDeviceIcons(data: DeviceState[]) {

    Log.debug("updateDeviceIcons: " + JSON.stringify(data));

    for (let i = 0; i < data.length; i++) {

      for (let j = 0; j < this.deviceList.length; j++) {

        if (data[i].serial == this.deviceList[j].serial) {

          this.deviceList[j].updateState(data[i]);
        }
      }
    }
  }

  modifyPermissions(device) {
    this.selectedDeviceEmitter.emit(device);
  }

  public mapReadyHandler(map: google.maps.Map): void {
    Log.debug("\n\n\n map ready");
    Log.debug("deviceList: ");
    Log.debug(this.deviceList);
    this.map = map;
    const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
    for (const device of this.deviceList) {
      bounds.extend(new google.maps.LatLng(device.latitude, device.longitude));
    }
    this.map.fitBounds(bounds);

    setTimeout(() => {
      Log.debug("\n\n\n this.zoom = " + this.map.getZoom());
      if (this.map.getZoom() > 20) {
        this.map.setZoom(20);
      } else if (this.map.getZoom() < 4) {
        this.map.setZoom(4);
      }
      Log.debug("\n\n\n this.zoom after changes = " + this.map.getZoom());
    }, 500);
  }


}
